var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('img',{key:_vm.currentImage,staticStyle:{"position":"absolute","left":"0","top":"0"},attrs:{"src":require(("../assets/" + _vm.currentImageSrc))}})])}
var staticRenderFns = []

export { render, staticRenderFns }